import { RefundReasonType } from "../enum/refund-reason-type";

export class RefundRequest{
    value:number;
    reason:RefundReasonType;
}